import React, { useEffect, useState } from 'react';
import { useNavigate, Link, useLocation } from "react-router-dom";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import MenuItem from '@mui/material/MenuItem';
import { useTheme } from "@mui/material/styles";
import { styled, alpha } from '@mui/material/styles';
import Menu from '@mui/material/Menu';
import { Typography } from "@mui/material";
import { signOut } from '../../Business/AuthenticationBusiness';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import { useAuthUser } from '../../Context/AuthUserContext';


const navToolbarItemSx = {
    display: "inline-flex",
    alignItems: "center",
    px: { xs: 1, md: 1 },
    py: 0,
    mt: 0,
};

export default function MenuLink(props) {
    const desktopSlot = props.desktopSlot;

    const [dark, setDark] = useState(false);
    const [login, setLogin] = useState(null);
    const [anchorElNav, setAnchorElNav] = useState(null);
    const [openDrawer, setOpenDrawer] = useState(true);
    const [openMyAccountDrawer, setOpenMyAccountDrawer] = useState(true);
    const [state, setState] = useState(false);
    const { authReady, isLoggedIn, profile, profileLoading } = useAuthUser();
    const location = useLocation();
    const freeCamiExist = (profile?.freeCamiCodes || 0) > 0;
    const camiforeverExist = (profile?.foreverCamiCodes || 0) > 0;
    const apiData = profile?.userPhoto || "";
    const hideGuestNavbarMenus = location.pathname === "/login";
    const navbarPending = !authReady || (isLoggedIn && profileLoading && !profile);
   
    useEffect(() => { setDark(props.dark); }, [props.dark]);
    useEffect(() => { setLogin(props.login); }, [props.login]);
    useEffect(() => { setState(props.state); }, [props.state]);
    const theme = useTheme();

    const mainColor = theme.palette.primary.main;
    const whiteColor = "#000";
    const inputFieldColor = "#EEF0F3";
    const secondary = "white";
    const defaultColor = theme.palette.primary.main;
    const subMenuTextStyle = {
        fontSize: 14,
        borderRadius: "8px",
        mx: 0.5,
        transition: "background-color 0.15s ease, color 0.15s ease",
        "&:hover": {
            backgroundColor: theme.palette.secondary.main,
            color: "#FFFFFF",
        },
    }
    const navigate = useNavigate();
    const StyledMenu = styled((props) => (
        <Menu
            elevation={0}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }}
            {...props}
        />
    ))(({ theme }) => ({
        '& .MuiPaper-root': {
            borderRadius: 6,
            marginTop: theme.spacing(1),
            minWidth: 180,
            color: theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
            boxShadow: 'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
            '& .MuiMenu-list': { padding: '4px 0', },
            '& .MuiMenuItem-root': {
                '& .MuiSvgIcon-root': {
                    fontSize: 18,
                    color: theme.palette.text.secondary,
                    marginRight: theme.spacing(1.5),
                },
                '&:active': {
                    backgroundColor: alpha(
                        theme.palette.primary.main,
                        theme.palette.action.selectedOpacity,
                    ),
                },
            },
        },
    }));

    const dropDownButtonStyle = {
        textTransform: "none",
        fontWeight: 600,
        color: theme.palette.primary.main,
        backgroundColor: "transparent",
        borderRadius: "10px",
        transition: "background-color 0.2s ease, color 0.2s ease",
        "&:hover": {
            backgroundColor: "rgba(24, 32, 104, 0.08)",
            color: theme.palette.primary.main,
        },
    }
    const disabledNavTextStyle = {
        textTransform: "capitalize",
        color: "rgba(24, 32, 104, 0.45)",
        backgroundColor: "transparent",
        boxShadow: "none",
        "&.Mui-disabled": {
            color: "rgba(24, 32, 104, 0.45)",
            backgroundColor: "transparent",
        },
    }

    function handleCloseNavMenu() {
        setAnchorElNav(null);
    }
    function toggleDrawer(openDrawer) {
        return function (event) {
            if (event && event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
                return;
            }
            setState(openDrawer);
            setOpenDrawer(false);
            setOpenMyAccountDrawer(false);
        }
    }
    // navigate login
    async function signOutAction() {
        try {
            await signOut();
        } finally {
            navigate('/login', { replace: true });
        }
    }


    function RenderDropdownButtonCreateCamicodeHeader() {
        const [anchorEl, setAnchorEl] = useState(null);
        const openRecorderMenu = Boolean(anchorEl);
        function handleClickSUbMenu(event) {
            setAnchorEl(event.currentTarget);
        };
        function handleClose() {
            setAnchorEl(null);
        };
        return (
            <Box sx={navToolbarItemSx}>
                <Button
                    id="demo-recorder-button"
                    aria-controls={openRecorderMenu ? 'demo-customized-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={openRecorderMenu ? 'true' : undefined}
                    variant="contained"
                    disableElevation
                    onClick={handleClickSUbMenu}
                    endIcon={<KeyboardArrowDownIcon />}
                    sx={dropDownButtonStyle}
                >
                    QR Codes
                </Button>
                <StyledMenu
                    id="demo-recorder-menu"
                    MenuListProps={{ 'aria-labelledby': 'demo-recorder-button', }}
                    anchorEl={anchorEl}
                    getcontentanchorel={null}
                    open={openRecorderMenu}
                    onClose={handleClose}>
                    <Link to="qr-steps" style={{ textDecoration: "none", color: defaultColor }} >
                        <MenuItem sx={subMenuTextStyle} onClick={handleClose} disableRipple>Create QR</MenuItem>
                    </Link>
                </StyledMenu>
            </Box>
        )
    }
    function RenderRoleBasedPrimaryButton() {
        return null;
    }

    function RenderRoleBasedSecondaryButton() {
        return null;
    }
    function RenderDropdownButtonMyCamicodeHeader() {
        const [anchorEl, setAnchorEl] = useState(null);
        const openSubMenu = Boolean(anchorEl);
        function handleClickSUbMenu(event) {
            setAnchorEl(event.currentTarget);
        };
        function handleClose() {
            setAnchorEl(null);
        };
        return (
            <Box sx={navToolbarItemSx}>
                <Button
                    id="demo-customized-button"
                    aria-controls={openSubMenu ? 'demo-customized-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={openSubMenu ? 'true' : undefined}
                    variant="contained"
                    disableElevation
                    onClick={handleClickSUbMenu}
                    endIcon={<KeyboardArrowDownIcon />}
                    sx={dropDownButtonStyle}
                >
                    My QR Codes
                </Button>
                <StyledMenu
                    id="demo-customized-menu"
                    MenuListProps={{ 'aria-labelledby': 'demo-customized-button', }}
                    anchorEl={anchorEl}
                    getcontentanchorel={null}
                    open={openSubMenu}
                    onClose={handleClose}>
                    <Link to="created-qrcode" style={{ textDecoration: "none", color: defaultColor }} >
                        <MenuItem sx={subMenuTextStyle} onClick={handleClose} disableRipple>
                            Created QR Codes
                        </MenuItem>
                    </Link>
                    <Link to="received-qrcode" style={{ textDecoration: "none", color: defaultColor }} >
                        <MenuItem sx={subMenuTextStyle} onClick={handleClose} disableRipple>
                            Received QR Codes
                        </MenuItem>
                    </Link>

                </StyledMenu>
            </Box>
        )
    }
    function RenderDropdownButtonMyAccountHeader() {
        const [anchorElAcc, setAnchorElAcc] = useState(null);
        const openSubMenuMyAccountHeader = Boolean(anchorElAcc);
        function handleClickSUbMenuMyAcc(event) {
            setAnchorElAcc(event.currentTarget);
        }
        function handleCloseMyAcc() {
            setAnchorElAcc(null);
        }
        return (
            <div style={{ paddingVertical: 6, paddingHorizontal: 8, marginTop: 16 }}>
                <Button
                    id="customized-button"
                    aria-controls={openSubMenuMyAccountHeader ? 'customized-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={openSubMenuMyAccountHeader ? 'true' : undefined}
                    variant="contained"
                    disableElevation
                    onClick={handleClickSUbMenuMyAcc}
                    endIcon={<KeyboardArrowDownIcon />}
                    sx={dropDownButtonStyle}
                >
                    My Account
                </Button>
                <StyledMenu
                    id="customized-menu"
                    MenuListProps={{ 'aria-labelledby': 'customized-button', }}
                    anchorEl={anchorElAcc}
                    getcontentanchorel={null}
                    open={openSubMenuMyAccountHeader}
                    onClose={handleCloseMyAcc}
                >
                    <Link to="my-payment-methods" style={{ textDecoration: "none", color: defaultColor }} >
                        <MenuItem sx={subMenuTextStyle} onClick={handleCloseMyAcc} disableRipple>My Payment Method  </MenuItem>
                    </Link>
                    <Link to="my-transaction" style={{ textDecoration: "none", color: defaultColor }} >
                        <MenuItem sx={subMenuTextStyle} onClick={handleCloseMyAcc} disableRipple>My Transactions </MenuItem>
                    </Link>
                    {freeCamiExist == true && <Link to="free-qr" style={{ textDecoration: "none", color: defaultColor }} >
                        <MenuItem sx={subMenuTextStyle} onClick={handleCloseMyAcc} disableRipple>Free QR Codes </MenuItem>
                    </Link>}
                    {camiforeverExist == true && <Link to="forever-qr" style={{ textDecoration: "none", color: defaultColor }} >
                        <MenuItem sx={subMenuTextStyle} onClick={handleCloseMyAcc} disableRipple>Bezohminds Forever </MenuItem>
                    </Link>}
                </StyledMenu>
            </div>
        )
    }

    
    function RenderProfile() {
        const [anchorEl, setAnchorEl] = useState(null);
        const isMenuOpen = Boolean(anchorEl);
        const handleProfileMenuOpen = (event) => {
            const value = event.currentTarget;
            setAnchorEl(value);

        };
        const handleMenuClose = () => {
            setAnchorEl(null);
        };


        return (
            <Box sx={{ flexGrow: 1, display: "flex", justifyContent: "flex-end"}}>
                <IconButton
                    size="large"
                    edge="end"
                    aria-label="image_of_current_user"
                    aria-haspopup="true"
                    onClick={handleProfileMenuOpen}
                    color="inherit"
                >
                    <Avatar src={apiData} alt="Profile_pic" />
                </IconButton>            
                <Menu
                    anchorEl={anchorEl}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    keepMounted
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    open={isMenuOpen}
                    onClose={handleMenuClose}
                >
                    <Link to="/my-profile" style={{ textDecoration: "none", color: defaultColor }} >
                        <MenuItem sx={subMenuTextStyle} onClick={handleMenuClose} disableRipple> My Profile</MenuItem>
                    </Link>
                    <Button onClick={signOutAction} style={{ color: defaultColor, textTransform: "capitalize", paddingLeft: "15px" }}  >
                        <Typography> Logout </Typography>
                    </Button>
                </Menu>
            </Box>
        );
    }

    function guestNavFragment() {
        if (hideGuestNavbarMenus || navbarPending || login === null) {
            return (
                <Box sx={navToolbarItemSx}>
                    <Link to="/scan-qr" style={{ textDecoration: "none", color: defaultColor }}>
                        <Button variant="contained" disableElevation sx={dropDownButtonStyle}>
                            Scan QR Code
                        </Button>
                    </Link>
                </Box>
            );
        }
        const guestNavButtonSx = {
            textTransform: "none",
            my: 0,
            color: theme.palette.primary.main,
            display: "block",
            fontWeight: 600,
            "&:hover": {
                backgroundColor: "rgba(24, 32, 104, 0.08)",
                color: theme.palette.primary.main,
            },
            "& .MuiTypography-root": {
                color: "inherit",
            },
        };
        const guestNavLinkStyle = { textDecoration: "none", color: theme.palette.primary.main };
        return (
            <>
                <Box sx={navToolbarItemSx}>
                    <Link to="/scan-qr" style={{ textDecoration: "none", color: defaultColor }}>
                        <Button variant="contained" disableElevation sx={dropDownButtonStyle}>
                            Scan QR Code
                        </Button>
                    </Link>
                </Box>
                <Box sx={navToolbarItemSx}>
                    <Button onClick={handleCloseNavMenu} sx={guestNavButtonSx}>
                        <Link style={guestNavLinkStyle} to="/login">
                            <Typography sx={{ color: "inherit", fontWeight: 600 }}>Login</Typography>
                        </Link>
                    </Button>
                </Box>
                <Box sx={navToolbarItemSx}>
                    <Button onClick={handleCloseNavMenu} sx={guestNavButtonSx}>
                        <Link style={guestNavLinkStyle} to="/register">
                            <Typography sx={{ color: "inherit", fontWeight: 600 }}>Register</Typography>
                        </Link>
                    </Button>
                </Box>
            </>
        );
    }

    function getDesktopCenterPaths() {
        if (navbarPending || login === null) {
            return guestNavFragment();
        }
        if (login === true) {
            return (
                <>
                    <RenderRoleBasedPrimaryButton />
                    <RenderRoleBasedSecondaryButton />
                </>
            );
        }
        return guestNavFragment();
    }

    if (desktopSlot === "center") {
        return (
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexWrap: "wrap",
                    gap: 1,
                    maxWidth: "100%",
                }}
            >
                {getDesktopCenterPaths()}
            </Box>
        );
    }

    if (desktopSlot === "profile") {
        if (navbarPending || login === null) {
            return null;
        }
        if (login === true) {
            return <RenderProfile />;
        }
        return null;
    }

    return null;
}